import { render, staticRenderFns } from "./NewTripDetails.vue?vue&type=template&id=5da8fd14&scoped=true"
import script from "./NewTripDetails.vue?vue&type=script&lang=js"
export * from "./NewTripDetails.vue?vue&type=script&lang=js"
import style0 from "./NewTripDetails.vue?vue&type=style&index=0&id=5da8fd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da8fd14",
  null
  
)

export default component.exports